import React from 'react';
import { useApp } from './Context';
import FilterOption from './FilterOption';

const filters = [
    { id: 'average_score', title: 'Average Score'},
    // { id: 'openness', title: 'Openness'},
    // { id: 'disruptive_conduct', title: 'Disruptive Conduct'},
    { id: 'speech_controversies', title: 'Speech Controversies'},
    { id: 'spotlight_rating', title: 'Spotlight Rating'},
];

function ChartFilters() {
    const { selectedFilter, setFilter } = useApp();

    const handleViewChange = (id) => {
        setFilter(id);
    };

    return (
        <div className="filter-panel">
            <fieldset className="trend-filters">
                <legend className="sr-only">View By</legend>
                <div className="filter-items">
                    {filters.map((option) => (
                        <FilterOption
                            key={option.id}
                            name="view_filter"
                            title={option.title}
                            id={option.id}
                            checked={selectedFilter === option.id}
                            onChange={() => handleViewChange(option.id)}
                        />
                    ))}
                </div>
            </fieldset>
        </div>
    );
}

export default ChartFilters;
